import classNames from "classnames";

import CheckMark from "@components/Icons/CheckMark";
import { resizeImage } from "@lib/helpers";

const ProductVariationOptionTextBox = ({ label, image, isSelected }) => (
  <div
    className={classNames(
      "flex flex-col gap-[4px] justify-center items-center px-[8px] py-[4px] rounded",
      {
        "border-2 border-[#FFC348]": isSelected,
        "bg-[#FFF9EB] border-2 border-transparent hover:border-[#FFC348]":
          !isSelected,
      }
    )}
    draggable={false}
  >
    {image && (
      <img
        src={resizeImage(image, "40x40")}
        alt={label}
        className="min-w-[40px] min-h-[40px] object-contain"
      />
    )}

    <p className="flex items-center justify-center gap-[4px] text-[14px]">
      {isSelected && <CheckMark />}
      {label}
    </p>
  </div>
);

export default ProductVariationOptionTextBox;
